export default __webpack_public_path__ + "static/media/Nodata.7f5b854f.png";